var map = {
	"./NewMain.vue": 37194,
	"./NewSidebar.vue": 86469,
	"./NewSidebarItem.vue": 42001,
	"./NewToolbar.vue": 14559,
	"./SidebarFilter.vue": 67613,
	"./SidebarItem.vue": 41335,
	"./SvgIcon.vue": 91937
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44085;